export const countryLanguageConfig = {
  AT: 'de',
  CZ: 'cs',
  DE: 'de',
  DK: 'da',
  ES: 'es',
  FI: 'fi',
  FR: 'fr',
  GB: 'en',
  GR: 'el',
  IT: 'it',
  NL: 'nl',
  NO: 'no',
  PT: 'pt',
  SE: 'sv',
  US: 'en',
};

/**
 * This config object defines which languages should be supported for each environment. For any
 * environment that is not defined in the config, the "default" value is used.
 */
export const environmentLanguageConfig = {
  default: ['de', 'en', 'es', 'fi', 'fr', 'it', 'nl', 'no', 'sv', 'pl', 'pt', 'cs', 'el'],
  staging: ['de', 'en', 'es', 'fi', 'fr', 'it', 'nl', 'no', 'sv', 'pl', 'pt', 'cs', 'el'],
  development: ['de', 'en', 'es', 'fi', 'fr', 'it', 'nl', 'no', 'sv', 'pl', 'pt', 'cs', 'el'],
};
